import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUserID } from "../Redux/UserSlice";
import { addCart } from "../Redux/CartSlice";
import { v4 as uuidv4 } from 'uuid';

import Loader from "react-js-loader";


const Login = () => {

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const Navigate = useNavigate();
  const userToggle = useSelector((state) => state.user.userToggle);

  // //retrieve the lastProductID from redux
  const lastProcuct = useSelector((state) => state.LP.product);
  // const lastProcuctD = useSelector((state)=>state.cart.lastProcuctID);
  // console.log(`The lastProductID = ${lastProcuct.productID}\n\n`);

  const fetchOneProductPrice = async (productid) => {

    await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/displayOneProductPrice", { productId: productid })
  }



  function validateEmail(email) {
    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return pattern.test(email);
  }


  const handleSubmit = async (e) => {
    e.preventDefault();



    if (!validateEmail(email)) {
      setMsg("Enter a valid email");
      setLoading(false);
      setTimeout(() => {
        setMsg('');

      }, 3000)
      return; // Exit the function if the email is not valid
    }

    try {



      setLoading(true);
      // console.log(1);


      const response = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/login", {
        email,
        password,
      });

      // console.log(2);
      if (response.data.admin === true) {
        sessionStorage.setItem('admin', true);
        setLoading(false);
        // console.log(3);
        // Navigate("/adminDashboard"); // Navigate to adminDashboard
        
        Navigate('/adminDashboard', { replace: true }); // Use replace method to navigate
        
      }
      else {

        // console.log(4);

        const foundUserIDResponse = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/FindOneUser", { email: email });
        const foundUserID = foundUserIDResponse.data._id;
        // console.log(5);
        // console.log(`\n\n\n\n\n\n foundUserID = ${foundUserID}\n\n\n\n\n\n`);
        if (response.status === 200) {
          // console.log(6);
          // console.log(`\n\n\n\n\n\n name = ${foundUserIDResponse.data.name}\n\n\n\n\n\n`);
          const user = {
            userID: foundUserID,
            name: foundUserIDResponse.data.name,
            email: foundUserIDResponse.data.email,
          };

          // console.log("Logged in successfully!");
          dispatch(setUserID(user));
          // console.log(`\n\nUser Found ID: ${foundUserID}\n\n`);
          // Navigate(`/home`);
          // console.log(7);
          const userItemsResponse = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/findItems", { user_id: foundUserID });
          // console.log(8);


          // console.log(`\n\n\nuserItemsResponse\n\n${JSON.stringify(userItemsResponse)}\n\n\n\n\n`);
          if (userItemsResponse && userItemsResponse.data && Array.isArray(userItemsResponse.data.items)) {
            const userItems = userItemsResponse.data.items;
            // console.log("userItems: ", userItems);
            const productPricePromises = userItems.map(item =>
              axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/displayOneProductPrice", { productId: item.product._id })
              // fetchOneProductPrice(item.product);
            );
            // console.log(9);

            try {
              const productPrices = await Promise.all(productPricePromises);

              userItems.forEach((item, index) => {
                const productPrice = productPrices[index].data.price;
                const productImage = productPrices[index].data.image;
                const proName = productPrices[index].data.proName;
                const tempprice = productPrice.replace(/,/g, '');
                const intPrice = parseInt(tempprice, 10);
                const totalPrice = item.quantity * intPrice;

                const idUU = uuidv4();

                const toSendItem = {
                  id: idUU,
                  productID: item.product,
                  proName: proName,
                  quantity: item.quantity,
                  subtotal: totalPrice,
                  total: totalPrice,
                  name: item.name,
                  number: item.number,
                  size: item.size,
                  price: productPrice,
                  image: `https://sportsblendserver.netlify.app/.netlify/images?url=/images/${productImage}`
                };

                // console.log(`\n\n\ntoSendItem\n\n${toSendItem.productID}\n\n\n\n\n`);
                // console.log(`\n\nadd cart = jallaaa To send\n\n\n\n\n\n\n`);
                // console.log(10);
                dispatch(addCart(toSendItem));
                // console.log(11);
              });

              try {
                // console.log(12);
                // console.log("lastProcuct, ", lastProcuct);


                if (lastProcuct && lastProcuct.id && lastProcuct.productID) {

                  const toSaveItem = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/createCart", {
                    user_id: foundUserID,
                    product_id: lastProcuct.productID,
                    quantity: lastProcuct.quantity,
                    name: lastProcuct.name,
                    number: lastProcuct.number,
                    size: lastProcuct.size,
                  });

                  // console.log(13);
                  // console.log(`\n\nThe product is saved in database\n${toSaveItem}`)

                }
              }
              catch (error) {
                setLoading(false);
                console.error("Error in saving cart item in db, Login.js", error);
              }

              if (userToggle) {
                // console.log(14);
                setLoading(false);
                // Navigate(`/home`);
                
                Navigate('/home', { replace: true }); // Use replace method to navigate
              } else {

                // console.log(15);
                // console.log(`\n\nadd cart = jallaaa LP ${lastProcuct.proName} \n ${lastProcuct.}\n\n\n\n\n\n\n`);
                dispatch(addCart(lastProcuct));

                // console.log(16);
                setLoading(false);
                // Navigate(`/productCustomize/${lastProcuct.productID}`);
                Navigate('/cart', { replace: true }); // Use replace method to navigate
              }

            } catch (error) {
              setLoading(false);
              // console.log(17);
              // Navigate(`/productCustomize/${lastProcuct.productID}`);
              Navigate('/cart', { replace: true }); // Use replace method to navigate
              
              console.error("Error fetching product prices:", error);
            }

          }
          else {
            setLoading(false);
            // console.log(18);

            try {
              // console.log(12);
              // console.log("lastProcuct, ", lastProcuct);


              if (lastProcuct && lastProcuct.id && lastProcuct.productID) {

                const toSaveItem = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/createCart", {
                  user_id: foundUserID,
                  product_id: lastProcuct.productID,
                  quantity: lastProcuct.quantity,
                  name: lastProcuct.name,
                  number: lastProcuct.number,
                  size: lastProcuct.size,
                });

                // Navigate(`/home`);
                // Navigate(`/productCustomize/${lastProcuct.productID}`);
                Navigate('/cart', { replace: true }); // Use replace method to navigate
                
                // console.log(13);
                // console.log(`\n\nThe product is saved in database\n${toSaveItem}`)

              }
              // Navigate(`/home`);

              Navigate('/home', { replace: true }); // Use replace method to navigate
            }
            catch (error) {
              setLoading(false);
              console.error("Error in saving cart item in db, Login.js", error);
              setMsg("Failed to login");
              setTimeout(() => {
                setMsg('');

              }, 3000)
              console.log("Failed to login");
            }

          }
        }
      }
    }
    catch (error) {
      setLoading(false);
      setMsg("Invalid Credentials")
      setTimeout(() => {
        setMsg('');

      }, 3000)
      console.log(error);
    }
  };
  const handleFindUser = async () => {
    try {
      // console.log(19);
      if (email !== "") {
        const response = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/FindOneUser", { email: email });
        // console.log(20);

        if (response.data) {
          // User found
          setMsg("User Found");
          setLoading(false);
          Navigate('/forgotpassword');
        } else {
          // User not found
          setMsg("User not Found");
        }
      } else {
        // Enter email
        setMsg("Enter email");
      }
    } catch (error) {
      // Handle other errors
      // console.log(21);
      console.error("Error finding user:", error);
      setMsg("No user is registered on this email.");
    }
  };


  const handlebtnSignup = () =>{
    // to="/signup" 
    Navigate('/signup', {replace: true})
  }

  return (
    <div className="root">
      <div className="containerleft">
        <h2 className="heading">Login</h2>
        <form className="signup-form" onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <div style={{ cursor: 'pointer' }} onClick={() => handleFindUser()}><p>Forgot Password</p></div>
          {/* <Link to='/forgotpassword'><p>Forgot Password</p></Link> */}
          {loading ? <Loader type="spinner-default" bgColor={'black'} size={30} /> : (
            <button type="submit" disabled={loading}>Login</button>
          )}
          <p style={{ color: 'red', textAlign: 'center' }}>{msg}</p>
        </form>
      </div>

      <div className="containerright">
        <div className="content">
          <h2 className="heading">Welcome Back </h2><br />
          <p className="subheading">Enter your personal details and start your journey with us</p>
          <button type="submit"  onClick={handlebtnSignup}><Link className='linkButtons' >Signup</Link></button>
        </div>
      </div>
    </div>
  );
};

export default Login;
